export default {
  tutorialVideo: '비디오 튜토리얼',
  text_1_1: '튜토리얼',

  text_2_1: '백업 튜토리얼',
  text_2_2: '가져오기 튜토리얼',
  text_2_3: '고급 튜토리얼(결제 기능)',
  text_2_4: '(결제)',

  text_3_1: '지갑 생성',
  text_3_1_1: '「Create Wallet」을 선택한 후 백업 절차로 진행합니다.',

  text_3_2: '백업',
  text_3_2_1:
    '백업 페이지에서 「KeyPal Card 백업」을 선택합니다. 전체 과정은 4단계: (1) 카드 PIN 설정; (2) 복구 구문을 카드에 백업; (3) 백업 정확성 검증; (4) 사용 시작.',
  text_3_2_2:
    '「백업 시작」을 누릅니다. 오류 방지를 위해 PIN을 두 번 입력합니다. PIN은 백업 보안과 카드 접근 제어를 위해 사용됩니다. 주의: PIN 보관 책임은 사용자에게 있으니 반드시 기억하세요!',
  text_3_2_3:
    'PIN 설정 후 안내에 따라 KeyPal Card를 휴대폰 후면 카메라(NFC 인식 구역)에 대세요. iOS에서는 안전 연결에 수 초가 걸릴 수 있으며, 짧은 지연은 정상입니다.',
  text_3_2_4:
    '인식이 완료되고 데이터가 정확하면 복구 구문이 암호화되어 카드에 기록됩니다. 완료 후 화면에 완료 알림이 표시됩니다.',
  text_3_2_5:
    '백업 완료 후 마지막 단계인 백업 검증으로 진행하세요. 수행을 강력히 권장합니다!',

  text_3_3: '검증',
  text_3_3_1:
    '검증 안내에 따라 이전에 설정한 카드 PIN을 입력하세요. 입력 후 카드 를 후면 카메라 근처에 가져가 NFC 인식을 진행합니다.',
  text_3_3_2:
    '검증이 성공하면 메시지가 표시됩니다. 니모닉 노출 방지를 위해 일부가 가려져 표시되며, 안내에 따라 단어를 확인하세요.',
  text_3_3_3:
    '검증 완료 후 「다음」을 눌러 바로 사용을 시작할 수 있습니다. 카드의 활용도와 보안을 높이기 위해 「결제 기능」도 제공하며, 자세한 내용은 「고급 기능 튜토리얼」을 참고하세요.',

  text_3_4: '유의사항',
  text_3_4_1:
    '1. TokenPocket은 PIN을 저장하지 않습니다. 반드시 스스로 기록·보관하세요.',
  text_3_4_2:
    '2. 각 카드의 PIN은 서로 다를 수 있습니다. 사용 중 10회 연속 오입력 시 카드 내 모든 데이터가 완전히 삭제됩니다.',
  text_3_4_3: '3. 백업에는 새 KeyPal Card 사용을 권장합니다.',
  text_3_4_4:
    '4. 카드를 초기화하면 모든 데이터가 완전하고 복구 불가능하게 삭제됩니다. 반드시 이해하시기 바랍니다.',
  text_3_4_5:
    '5. iOS 백업/사용 시 속도가 느릴 수 있습니다. 정상 동작이니 기다려 주세요.',

  text_4_1: '가져오기 튜토리얼',
  text_4_2_1:
    '백업된 KeyPal Card가 있으면, 카드에 백업된 지갑을 TokenPocket으로 가져와 사용할 수 있습니다. 단일 네트워크/다중 네트워크 가져오기를 지원하며, 여기서는 단일과 유사한 다중 네트워크 방식을 중심으로 설명합니다.',
  text_4_3_1:
    '1. 「지갑 가져오기」에서 「KeyPal 하드웨어 지갑」을 선택한 뒤, 팝업에서 KeyPal Card를 가져오기 방식으로 선택합니다.',
  text_4_3_2:
    '2. KeyPal Card를 선택한 후 「가져오기 시작」을 누르고 카드 PIN을 입력합니다.',
  text_4_3_3:
    '3. PIN 입력 후 스캔 페이지가 나타납니다. 카드를 후면 카메라 근처에 가져가고, 「스캔 시작」을 눌러 NFC 인식 및 읽기를 시작합니다. iOS에서는 시간이 더 걸릴 수 있습니다.',
  text_4_3_4:
    '4. 복구 구문 읽기에 성공하면 알림이 표시됩니다. 「다음」을 눌러 네트워크를 선택하고 지갑을 생성하세요. 카드의 활용도와 보안을 높이기 위한 「결제 기능」은 「고급 기능 튜토리얼」을 참고하세요.',

  text_4_4: '유의사항',
  text_4_4_1:
    '1. iOS 백업/사용은 다소 느릴 수 있습니다. 정상입니다.',
  text_4_4_2:
    '2. 읽기 전 PIN 입력이 필요합니다. 10회 연속 오입력 시 카드가 모든 데이터를 자동 삭제합니다. 올바르게 입력하면 오류 횟수는 0으로 초기화됩니다.',
  text_4_4_3:
    '3. 「결제 기능」 사용 시 복구 구문은 휴대폰에 저장되지 않습니다. 매 거래마다 카드를 스캔해 서명해야 합니다.',

  text_5_1: '고급 튜토리얼',
  text_5_2_1:
    '결제 기능은 니모닉/개인키를 오프라인(휴대폰 미저장) 상태로 더 안전하게 유지하면서 카드의 활용도를 높입니다.',
  text_5_3_1:
    '1. 생성/가져오기 시 고급 옵션에서 복구 구문/개인키를 기기에 저장하지 않도록 선택할 수 있습니다. 이후 거래는 카드 스캔으로 서명합니다.',
  text_5_3_2:
    '2. 송금이나 DApp 거래를 시작하면 하단에 「카드 스캔하여 결제」가 표시됩니다. 탭하여 결제 플로우를 시작합니다.',
  text_5_3_3:
    '3. 「카드 스캔하여 결제」 후 본인 확인을 위해 카드 PIN을 입력합니다.',
  text_5_3_4:
    '4. 안내에 따라 카드를 대어 읽기와 서명을 수행합니다. 서명 후 거래는 블록체인으로 전송됩니다.',

  text_5_4: '유의사항',
  text_5_4_1:
    '1. 읽기 전 PIN 입력이 필요합니다. 10회 연속 실패 시 모든 데이터가 삭제되며, 올바른 입력 시 카운트가 초기화됩니다.',
  text_5_4_2:
    '2. 「결제 기능」 사용 시 복구 구문은 휴대폰에 저장되지 않으며, 매번 카드 스캔으로 서명해야 합니다.',
};
